export const issues = [
  {
    id: 'ISS-001',
    title: 'Cannot access Professional Skills module',
    description: 'I completed Digital Literacy Fundamentals but Professional Skills Development shows as locked',
    priority: 'high',
    status: 'resolved',
    category: 'technical',
    reportedBy: '1',
    reportedByName: 'Thabo Mthembu',
    assignedTo: '3',
    assignedToName: 'Sarah Johnson',
    createdAt: '2025-07-15T10:30:00Z',
    updatedAt: '2025-07-17T09:15:00Z',
    resolvedAt: '2025-07-17T09:15:00Z',
    comments: [
      {
        id: 'COM-001',
        author: '1',
        authorName: 'Thabo Mthembu',
        content: 'I completed all lessons in Digital Literacy Fundamentals but Professional Skills Development still shows as locked',
        createdAt: '2025-07-15T10:30:00Z'
      },
      {
        id: 'COM-002',
        author: '3',
        authorName: 'Sarah Johnson',
        content: 'Hi Thabo, I can see you have 80% completion. You need to complete the final project to unlock the next module. Please finish the Digital Portfolio Setup project.',
        createdAt: '2025-07-17T09:15:00Z'
      }
    ]
  },
  {
    id: 'ISS-002',
    title: 'Video not playing in Internet Navigation lesson',
    description: 'The Internet Navigation & Safety video is not loading properly',
    priority: 'medium',
    status: 'in_progress',
    category: 'technical',
    reportedBy: '5',
    reportedByName: 'Sipho Ngwenya',
    assignedTo: '4',
    assignedToName: 'Aasiyah Adams',
    createdAt: '2025-07-16T14:20:00Z',
    updatedAt: '2025-07-16T15:45:00Z',
    comments: [
      {
        id: 'COM-002',
        author: '5',
        authorName: 'Sipho Ngwenya',
        content: 'The video shows a loading spinner but never actually loads. I\'ve tried refreshing and different browsers.',
        createdAt: '2025-07-16T14:20:00Z'
      },
      {
        id: 'COM-003',
        author: '4',
        authorName: 'Aasiyah Adams',
        content: 'Thanks for reporting this. I\'ve identified the issue with our video hosting service. Working on a fix now.',
        createdAt: '2025-07-16T15:45:00Z'
      }
    ]
  },
  {
    id: 'ISS-003',
    title: 'Request for additional practice exercises',
    description: 'Would like more practice exercises for React hooks',
    priority: 'low',
    status: 'open',
    category: 'content',
    reportedBy: '1',
    reportedByName: 'Learner One',
    assignedTo: '3',
    assignedToName: 'Facilitator One',
    createdAt: '2025-07-17T09:15:00Z',
    updatedAt: '2025-07-17T09:15:00Z',
    comments: [
      {
        id: 'COM-004',
        author: '1',
        authorName: 'Learner One',
        content: 'The React hooks lesson is great but I would benefit from more hands-on exercises',
        createdAt: '2025-07-17T09:15:00Z'
      }
    ]
  },
  {
    id: 'ISS-004',
    title: 'Document upload failing',
    description: 'Getting error when trying to upload ID document',
    priority: 'high',
    status: 'resolved',
    category: 'technical',
    reportedBy: '5',
    reportedByName: 'Learner Three',
    assignedTo: '4',
    assignedToName: 'System Administrator',
    createdAt: '2025-07-14T16:00:00Z',
    updatedAt: '2025-07-15T11:30:00Z',
    resolvedAt: '2025-07-15T11:30:00Z',
    comments: [
      {
        id: 'COM-005',
        author: '5',
        authorName: 'Learner Three',
        content: 'Error message: "Upload failed. Please try again."',
        createdAt: '2025-07-14T16:00:00Z'
      },
      {
        id: 'COM-006',
        author: '4',
        authorName: 'System Administrator',
        content: 'Fixed the file upload service. Should work now.',
        createdAt: '2025-07-15T11:30:00Z'
      }
    ]
  }
];

export const issueCategories = [
  { id: 'technical', name: 'Technical Issue', color: 'danger' },
  { id: 'content', name: 'Content Request', color: 'info' },
  { id: 'account', name: 'Account Issue', color: 'warning' },
  { id: 'general', name: 'General Inquiry', color: 'secondary' }
];

export const issuePriorities = [
  { id: 'low', name: 'Low', color: 'success' },
  { id: 'medium', name: 'Medium', color: 'warning' },
  { id: 'high', name: 'High', color: 'danger' },
  { id: 'critical', name: 'Critical', color: 'dark' }
];

export const issueStatuses = [
  { id: 'open', name: 'Open', color: 'primary' },
  { id: 'in_progress', name: 'In Progress', color: 'warning' },
  { id: 'resolved', name: 'Resolved', color: 'success' },
  { id: 'closed', name: 'Closed', color: 'secondary' }
];